"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityConversationLayout = exports.EntityConversationLayoutDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var theme_2 = require("@shapeable/theme");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var entity_conversation_1 = require("./entity-conversation");
var use_app_layout_1 = require("../../hooks/use-app-layout");
var client_1 = require("@apollo/client");
var loading_layout_1 = require("../elements/loading-layout");
var use_lang_1 = require("../../hooks/use-lang");
var react_infinite_scroll_hook_1 = __importDefault(require("react-infinite-scroll-hook"));
var fetch_more_params_1 = require("../../utils/fetch-more-params");
var wait_message_1 = require("../elements/wait-message");
var react_idle_timer_1 = require("react-idle-timer");
exports.EntityConversationLayoutDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_2.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    overflow: auto;\n    display: flex;\n    flex-direction: column-reverse;\n    ", "\n"], ["\n    position: relative;\n    overflow: auto;\n    display: flex;\n    flex-direction: column-reverse;\n    ", "\n"])), function (props) {
    return props._height && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), props._height);
  })
});
var ConversationStyles = (0, theme_2.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var WaitMessageStyles = (0, theme_2.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme_1.theme.UNIT(-10))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  LoadingLayout: loading_layout_1.LoadingLayout,
  Conversation: (0, styled_components_1.default)(entity_conversation_1.EntityConversation)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ConversationStyles),
  WaitMessage: (0, styled_components_1.default)(wait_message_1.WaitMessage)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), WaitMessageStyles)
};
var EntityConversationLayout = function (props) {
  var className = props.className,
    entity = props.entity;
  // // use a local state bucket to store submitted comments while awaiting actual submission
  var _a = __read((0, react_1.useState)([]), 2),
    comments = _a[0],
    setComments = _a[1];
  var definition = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var t = (0, use_lang_1.useLang)();
  var layoutInfo = (0, use_app_layout_1.useAppLayout)();
  var availableHeight = layoutInfo.availableHeight;
  var variables = {
    limit: 5,
    id: entity && entity.slug
  };
  var _b = (0, client_1.useQuery)(definition.commentsQuery, {
      fetchPolicy: "network-only",
      notifyOnNetworkStatusChange: true,
      variables: variables
    }),
    data = _b.data,
    loading = _b.loading,
    fetchMore = _b.fetchMore,
    refetch = _b.refetch;
  var list = data && data.listComments;
  var items = list && list.results || [];
  var itemIds = items.map(function (item) {
    return item.id;
  }).join(',');
  var _c = __read((0, react_1.useState)(false), 2),
    isIdle = _c[0],
    setIsIdle = _c[1];
  // const [ isPollingActive, setIsPollingActive ] = useState<boolean>(true);
  // setup conversation refresh
  var intervalID;
  (0, react_1.useEffect)(function () {
    if (!isIdle) {
      intervalID = setInterval(function () {
        refetch();
      }, 10000);
    } else {
      clearInterval(intervalID);
    }
    return function () {
      return clearInterval(intervalID);
    };
  }, [isIdle]);
  var idleTimer = (0, react_idle_timer_1.useIdleTimer)({
    onIdle: function () {
      setIsIdle(true);
    },
    onActive: function () {
      refetch();
      setIsIdle(false);
    },
    // 10 seconds
    timeout: 1000 * 60 * 0.1
  });
  var meta = data && data.listComments && data.listComments.meta || {
    count: 0,
    total: 0
  };
  var hasNextPage = meta.total > items.length;
  var params = (0, fetch_more_params_1.fetchMoreParams)(variables, comments, 'listComments', true);
  (0, react_1.useEffect)(function () {
    setComments(items);
  }, [itemIds]);
  var onLoadMore = function () {
    fetchMore(params);
  };
  var _d = __read((0, react_infinite_scroll_hook_1.default)({
      loading: loading,
      hasNextPage: hasNextPage,
      onLoadMore: onLoadMore,
      disabled: false,
      rootMargin: '0px 0px 100px 0px'
    }), 2),
    sentryRef = _d[0],
    rootRef = _d[1].rootRef;
  // const handleInputBlur = () => {
  //   setIsPollingActive(true);
  // }
  // const handleInputFocus = () => {
  //   setIsPollingActive(false);
  // }
  return react_1.default.createElement(My.Container, {
    _height: availableHeight,
    className: className,
    ref: rootRef
  }, react_1.default.createElement(My.Conversation, {
    entity: entity,
    stretch: true,
    comments: comments,
    setComments: setComments
  }), (loading || hasNextPage) && !(!loading && items.length === 0) && react_1.default.createElement("div", {
    ref: sentryRef
  }));
};
exports.EntityConversationLayout = EntityConversationLayout;
exports.EntityConversationLayout.defaultProps = exports.EntityConversationLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;